import * as React from 'react'
import { StoreProps } from "../../../../services/stores/casting.store"
import CastingLodgingNewComponent from './casting-lodging-new.component'
import { ThemeProvider, useTheme } from 'styled-components'
import SelectableListComponent from '../../../shared/selectable-list.component'
import { I18nService } from '../../../../services/utils/i18n.service'

const i18nScoped = new I18nService(require('./casting-lodging-content.component.yml'))

export default function CastingLodgingContentComponent ({ store, data, data: { lodging, customer, city, market } }: StoreProps) {
  const theme = useTheme()
  const sameLocationLodgings = React.useMemo(
    () => customer?.lodgings.filter(aLodging => {
      const addr = aLodging.address_attributes
      return addr.city && addr.city === city.city || addr.zipcode && addr.zipcode === city.postalCode
    }) || [],
    [city.city, city.postalCode, customer?.lodgings]
  )

  const setNewLodging = React.useCallback(() => {
    store.set({
      lodging: {
        name: '',
        ical_url: '',
        checkin_time: null,
        checkout_time: null,
        address_attributes: {
          street: '',
          city: '',
          zipcode: '',
          country: market.coverage !== 'worldwide' ? market.country : '',
          state: '',
          additional: ''
        }
      }
    })
  }, [market.country, market.coverage, store])

  React.useEffect(() => {
    if (!lodging && !sameLocationLodgings.length) setNewLodging()
  }, [sameLocationLodgings.length, lodging, setNewLodging])

  if (sameLocationLodgings.length && (!lodging || 'id' in lodging)) {
    return <>
      <p>{ i18nScoped.t('choose_between_existing') }</p>
      <ThemeProvider theme={{ ...theme, selectableListOnComputerWithOuterBorder: false }}>
        <SelectableListComponent
          name="lodging"
          data={ sameLocationLodgings }
          value={ lodging as null | typeof customer.lodgings[0] }
          formatter={ lodging => <>
            <b>{ lodging.name }</b>
            <div>{ lodging.address_attributes.street }, { lodging.address_attributes.city } ({ lodging.address_attributes.zipcode })</div>
          </> }
          onChange={ value => {
            store.set({ lodging: value })
            store.nextFocus()
          } } />
      </ThemeProvider>

      <a onClick={ setNewLodging } style={{ marginTop: '1em', marginBottom: '2em', display: 'block' }}>
        { i18nScoped.t('create_new') }
      </a>
    </>
  }

  return <CastingLodgingNewComponent store={ store } data={ data } />
}
